import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CompletionProvider, CompletionModelDTO } from '@app-libs/model';
import { ConfigurationClientService } from '../client/configuration-client.service';
import { ApiClient } from '../client/api-client';

@Injectable({
  providedIn: 'root',
})
export class CompletionProvidersApiService extends ApiClient {
  override get baseUrl(): string {
    return this.config.getBackendAPIUrl() + '/completions';
  }

  constructor(config: ConfigurationClientService, http: HttpClient) {
    super(config, http);
  }

  // *************** Completion Providers ***************

  getProviders(): Observable<CompletionProvider[]> {
    return this.http.get<CompletionProvider[]>(`${this.baseUrl}/providers`);
  }

  getProviderById(providerId: string): Observable<CompletionProvider> {
    return this.http.get<CompletionProvider>(`${this.baseUrl}/providers/${providerId}`);
  }

  createProvider(provider: CompletionProvider): Observable<CompletionProvider> {
    return this.http.post<CompletionProvider>(`${this.baseUrl}/providers`, provider);
  }

  updateProvider(providerId: string, provider: CompletionProvider): Observable<CompletionProvider> {
    return this.http.patch<CompletionProvider>(`${this.baseUrl}/providers/${providerId}`, provider);
  }

  deleteProvider(providerId: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/providers/${providerId}`);
  }

  // *************** Completion Models ***************

  getModels(): Observable<CompletionModelDTO[]> {
    return this.http.get<CompletionModelDTO[]>(`${this.baseUrl}/models`);
  }

  getModelById(modelId: string): Observable<CompletionModelDTO> {
    return this.http.get<CompletionModelDTO>(`${this.baseUrl}/models/${modelId}`);
  }

  getModelsByProvider(providerId: string): Observable<CompletionModelDTO[]> {
    return this.http.get<CompletionModelDTO[]>(`${this.baseUrl}/providers/${providerId}/models`);
  }

  createModel(model: CompletionModelDTO): Observable<CompletionModelDTO> {
    return this.http.post<CompletionModelDTO>(`${this.baseUrl}/models`, model);
  }

  updateModel(modelId: string, model: CompletionModelDTO): Observable<CompletionModelDTO> {
    return this.http.patch<CompletionModelDTO>(`${this.baseUrl}/models/${modelId}`, model);
  }

  deleteModel(modelId: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/models/${modelId}`);
  }
}
